import React, { useState } from 'react'
import Bredcrumb from '../Common/Bredcrumb'
import {} from 'react-router-dom'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
const DandiyaNight = () => {

    const images = [
        'img/dandiya/1000051319.png',
        'img/dandiya/1000051320.png',
        'img/dandiya/1000051321.png',
        'img/dandiya/1000051322.png',
        'img/dandiya/1000051323.png',
        'img/dandiya/1000051324.png',
        'img/dandiya/1000051325.png',
        'img/dandiya/1000051326.png',
        'img/dandiya/1000051327.png',
        'img/dandiya/1000051328.png',
        'img/dandiya/1000051329.png',
        'img/dandiya/1000051330.png',
        'img/dandiya/1000051331.png',
        'img/dandiya/1000051332.png',
        'img/dandiya/1000051333.png',        
       ];
    
      const [isOpen, setIsOpen] = useState(false);
      const [photoIndex, setPhotoIndex] = useState(0);
      const [loading, setLoading] = useState(false);
    
      const openLightbox = (index) => {
        setPhotoIndex(index);
        setIsOpen(true);
        setLoading(true);
      };
    
      const closeLightbox = () => {
        setIsOpen(false);
        setLoading(false);
      };
    
      const onImageLoad = () => {
        setLoading(false);
      };

      
  return (
    <>
      <Bredcrumb title="Dandiya Night" />
      <section className="facility-box mt-4">
        <div className="container">          
          <div className="row mb-4">
                    <div className="col-md-12">
                            <div className="gallery text-center row">
                            {images.map((image, index) => (
                            <div key={index} className="col-md-4 mb-4">
                                <div className='gallery-block'>
                                    <img src={image} alt={`Image ${index + 1}`} onClick={() => openLightbox(index)} style={{cursor: 'pointer' }} />
                                </div>
                            </div>
                            ))}
                            {isOpen && (
                                <Lightbox
                                    mainSrc={images[photoIndex]}
                                    nextSrc={images[(photoIndex + 1) % images.length]}
                                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                                    onCloseRequest={closeLightbox}
                                    onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
                                    onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
                                    imageLoadErrorHandler={() => setLoading(false)}
                                    onImageLoad={onImageLoad}
                                />
                            )}
                            {loading && <div className="loading-indicator">Loading...</div>}

                               
                            </div>
                    </div>
                </div>	           
          </div>
        </section>
    </>
  )
}

export default DandiyaNight
